module.exports = __webpack_public_path__ + "img/swiper_3.0_5_3.e5f954dc.webp";